import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-root',
  template: `
    <app-auth-nav></app-auth-nav>
    <router-outlet></router-outlet>
  `,
  styleUrls: ['./root.component.scss']
})
export class RootComponent implements OnInit {
  constructor() { }

  ngOnInit() { }
}
